import { render } from "./loader.svg?vue&type=template&id=77233046?inline"
const script = {}
script.render = render

export default script